import { type IStatusUpdate, StreamStatus } from "@multimediallc/web-utils"
import { createSlice } from "@reduxjs/toolkit"

export interface BroadcastState {
    streamStatus?: IStatusUpdate
}

const initialState: BroadcastState = {
    streamStatus: undefined,
}

export const broadcastSlice = createSlice({
    name: "broadcast",
    initialState: initialState,
    reducers: {
        updateStreamStatus: (state, action) => {
            state.streamStatus = action.payload
        },
    },
})

export const { updateStreamStatus } = broadcastSlice.actions

export const selectStreamFPS = (state: {
    broadcast: BroadcastState
}): number => {
    const { streamStatus } = state.broadcast
    return streamStatus?.data?.fps ?? 0
}

export const selectStreamStatus = (state: {
    broadcast: BroadcastState
}): StreamStatus => {
    const { streamStatus } = state.broadcast
    const currentStatus = streamStatus?.data?.status as StreamStatus
    const roomPassword = streamStatus?.data?.roomPassword
    if (
        currentStatus === StreamStatus.Public &&
        roomPassword !== undefined &&
        roomPassword !== ""
    ) {
        return StreamStatus.PasswordProtected
    }
    return currentStatus ?? StreamStatus.Unknown
}

export default broadcastSlice.reducer
